import { api } from "@/api/client";
import type { AuthMode } from "@/types/api";

/** Справочник баз 1С для SSO-режима (`backend/.../onec_bases`). В SSO-сессии
 *  портал ходит в 1С по JWT именно в эти базы, а не в личные подключения с
 *  паролем. Заводит админ, общий для всех. */
export interface OneCBase {
  id: string;
  name: string;
  /** Адрес публикации без `/odata/…` и `/hs/…`. */
  base_url: string;
  /** `aud` токена — ровно как в `default.vrd` публикации. */
  audience: string;
  config_type: string;
  is_default: boolean;
  created_at: string;
  updated_at: string;
}

/** Справочник + состояние ТЕКУЩЕЙ сессии (для выбора базы и индикатора). */
export interface OneCBaseList {
  bases: OneCBase[];
  /** Выбранная человеком база; null — не выбирал (действует по умолчанию). */
  selected_id: string | null;
  /** Действующая база SSO-режима; null — нет ни выбранной, ни по умолчанию. */
  effective_id: string | null;
  auth_mode: AuthMode;
  /** Есть ли у SSO-сессии пользователь 1С (`onec_unf`). Для не-SSO — false. */
  has_onec_unf: boolean;
}

export interface OneCBaseCreate {
  name: string;
  base_url: string;
  audience: string;
  config_type: "unf";
  is_default: boolean;
}

export interface OneCBaseUpdate {
  name?: string;
  base_url?: string;
  audience?: string;
  is_default?: boolean;
}

/** Конфигурации 1С справочника: бэкенд пока принимает только УНФ. */
export const CONFIG_TYPE_TITLES: Record<string, string> = { unf: "УНФ" };

export const ONEC_BASES_QUERY_KEY = ["onec-bases"] as const;

export async function listOneCBases(): Promise<OneCBaseList> {
  const { data } = await api.get<OneCBaseList>("/onec-bases");
  return data;
}

/** `null` — вернуться к базе по умолчанию. */
export async function selectOneCBase(baseId: string | null): Promise<OneCBaseList> {
  const { data } = await api.put<OneCBaseList>("/onec-bases/selected", { base_id: baseId });
  return data;
}

export async function createOneCBase(body: OneCBaseCreate): Promise<OneCBase> {
  const { data } = await api.post<OneCBase>("/onec-bases", body);
  return data;
}

export async function updateOneCBase(id: string, body: OneCBaseUpdate): Promise<OneCBase> {
  const { data } = await api.put<OneCBase>(`/onec-bases/${id}`, body);
  return data;
}

export async function deleteOneCBase(id: string): Promise<void> {
  await api.delete(`/onec-bases/${id}`);
}
